import {Html5Qrcode, Html5QrcodeSupportedFormats} from 'html5-qrcode';

export class QrScanner {
    private readonly id: string;
    private readonly qrcodeScanner: Html5Qrcode;

    constructor(id: string, onSuccess?: (decodedText: string) => void, onError?: (error: string) => void) {
        this.id = id;

        this.qrcodeScanner = new Html5Qrcode(
            this.id, {
                experimentalFeatures: undefined,
                useBarCodeDetectorIfSupported: false,
                verbose: false,
                formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
            });

        const config = {fps: 10, qrbox: {width: 300, height: 300}, rememberLastUsedCamera: true};

        this.qrcodeScanner.start({facingMode: "environment"}, config, onSuccess.bind(this), onError.bind(this));
    }

    public getScanner(): Html5Qrcode {
        return this.qrcodeScanner;
    }
}

